import * as React from "react";

type PropsType = {
    children?: React.ReactNode;
    className?: string;
    inverted?: boolean;
    color?:
        | "dark"
        | "green"
        | "lime-green"
        | "pink"
        | "stain"
        | "outline"
        | "error"
        | "red"
        | "grey"
        | "dark-grey"
        | "grey-contrast"
        | "amber";
    size?: "lg";
};

function Pill({
    className = "",
    color = "dark",
    children,
    inverted = false,
    size,
    ...props
}: PropsType) {
    const classList = ["pill", `pill--${color}`];
    if (className) {
        classList.push(className);
    }

    if (size) {
        classList.push(`pill--${size}`);
    }

    if (inverted) {
        classList.push(`pill--inverted`);
    }

    return (
        <span {...props} className={classList.join(" ")}>
            {children}
        </span>
    );
}

export default Pill;
